<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"><img src="../assets/logo-sm-icon.png" /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link active" aria-current="page" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/assessments">My Assessments</router-link>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto"> <!-- ml-auto to align right -->
          <li class="nav-item">
            <a class="nav-link" href="#" @click="logout()">Logout</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { deleteAllCookies } from '@/utils/cookies/cookieUtils.js';
export default {  
  data() {
    return {

    };
  },
  methods: {
    logout() {
      // Deleting cookies, forcing logout.
      //deleteCookie('token');
      //deleteCookie('userid');
      deleteAllCookies();
    }
  }
};
</script>